import React from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '../../lib/cn';

export default function EmptyState({
  title = 'Sin datos disponibles',
  description = 'Aún no hay información para mostrar en esta sección.',
  icon: Icon = Inbox,
  action,
  className = '',
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-2xl border border-dashed border-gray-300 dark:border-gray-700 bg-white/80 dark:bg-gray-900/50 p-10 text-center  backdrop-blur-sm',
        className
      )}
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-400">
        <Icon className="h-8 w-8" />
      </div>
      <h3 className="mt-6 text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-gray-600 dark:text-gray-400">{description}</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
